/*
  Bundle-cover previews (page.packages-bundles-modal / -inline / -replace)
  — loaded ONLY by those templates, BEFORE assets/packages.js:
    <script src="{{ 'packages-bundles.js' | asset_url }}" defer></script>
    <script src="{{ 'packages.js' | asset_url }}" defer></script>
  Hand-written ES5, like packages.js.

  packages.js already does the real work: a tile is a [data-package-select]
  button, so its click switches the details card to that package. This
  file only reveals or hides that card, as the container's
  data-packages-bundles mode says (snippets/packages-bundles.liquid):
    modal    dialog over the page; Escape, backdrop and × close it
    inline   card unfolds under the tiles and scrolls into view
    replace  tiles hide, card shows with an "All bundles" button back
  #<package-id> opens that bundle on load, like the table page; in modal
  and replace, opening pushes a history entry so Back closes it (the
  careers job-modal behaviour).

  Load order matters: packages.js always selects a package on load and
  writes it to the hash (#comfort when there was none), so the hash the
  visitor actually arrived with is read here first.
*/
(function () {
  var bundles = document.querySelector('[data-packages-bundles]');
  if (!bundles) return;
  var arrivalHash = location.hash.replace('#', '');

  var mode = bundles.getAttribute('data-packages-bundles');
  var grid = bundles.querySelector('[data-packages-bundle-grid]');
  var details = bundles.querySelector('[data-packages-bundle-details]');
  var entering = bundles.querySelector('[data-packages-bundle-entering]');
  var tiles = Array.prototype.slice.call(bundles.querySelectorAll('[data-packages-bundle-tile]'));
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var usesHistoryEntry = mode === 'modal' || mode === 'replace';

  var openPackageId = null;
  var pushedHistoryEntry = false;
  var openingFromUrl = false;

  function tileFor(packageId) {
    return tiles.filter(function (tile) { return tile.getAttribute('data-packages-bundle-tile') === packageId; })[0] || null;
  }

  function pageUrl() { return location.pathname + location.search; }

  function markTiles(packageId) {
    tiles.forEach(function (tile) {
      tile.setAttribute('aria-pressed', tile.getAttribute('data-packages-bundle-tile') === packageId ? 'true' : 'false');
    });
  }

  function replayEntrance() {
    if (!entering) return;
    entering.classList.remove('packages-panel-entering');
    void entering.offsetWidth;
    entering.classList.add('packages-panel-entering');
  }

  function scrollIntoViewIfBelowFold() {
    var top = details.getBoundingClientRect().top;
    if (top < window.innerHeight * 0.6) return;
    details.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* Called once packages.js has switched the card to packageId. */
  function openBundle(packageId, fromUrl) {
    var wasOpen = openPackageId !== null;
    openPackageId = packageId;
    markTiles(packageId);
    details.hidden = false;
    if (!wasOpen) replayEntrance();

    if (mode === 'modal') {
      document.body.classList.add('packages-bundle-modal-lock');
      var closeButton = details.querySelector('.packages-bundle-modal-close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    } else if (mode === 'replace') {
      grid.hidden = true;
      var backButton = details.querySelector('.packages-bundle-back');
      if (backButton) backButton.focus({ preventScroll: true });
      var bundlesTop = bundles.getBoundingClientRect().top;
      if (bundlesTop < 0) bundles.scrollIntoView({ behavior: 'auto', block: 'start' });
    } else {
      window.requestAnimationFrame(scrollIntoViewIfBelowFold);
    }

    /* packages.js has already replaced the hash with #packageId; turn that
       into a new entry so Back closes the bundle instead of leaving the page. */
    if (usesHistoryEntry && !fromUrl && !pushedHistoryEntry && history.pushState) {
      history.replaceState(null, '', pageUrl());
      history.pushState(null, '', pageUrl() + '#' + packageId);
      pushedHistoryEntry = true;
    }
  }

  /* fromUrl: the hash already changed (Back, a typed link), so leave history alone. */
  function closeBundle(fromUrl) {
    if (openPackageId === null) return;
    var tile = tileFor(openPackageId);
    openPackageId = null;
    markTiles(null);
    details.hidden = true;
    if (mode === 'modal') document.body.classList.remove('packages-bundle-modal-lock');
    if (mode === 'replace') grid.hidden = false;
    if (tile) tile.focus({ preventScroll: mode !== 'replace' });

    if (fromUrl) { pushedHistoryEntry = false; return; }
    if (pushedHistoryEntry) {
      pushedHistoryEntry = false;
      history.back();
    } else if (history.replaceState) {
      history.replaceState(null, '', pageUrl());
    }
  }

  /* Opening from the URL goes through the tile's own click, so packages.js
     selects the package exactly as it does for a shopper's click. */
  function openFromUrl(packageId) {
    var tile = tileFor(packageId);
    if (!tile || openPackageId === packageId) return;
    openingFromUrl = true;
    tile.click();
    openingFromUrl = false;
  }

  /* Listens on document, so it runs after packages.js's listener on the
     page element has already switched the card. */
  document.addEventListener('click', function (event) {
    var tile = event.target.closest('[data-packages-bundle-tile]');
    if (tile && bundles.contains(tile)) {
      var packageId = tile.getAttribute('data-packages-bundle-tile');
      if (mode === 'inline' && !openingFromUrl && openPackageId === packageId) { closeBundle(false); return; }
      openBundle(packageId, openingFromUrl);
      return;
    }
    if (event.target.closest('[data-packages-bundle-close]') && bundles.contains(event.target)) {
      event.preventDefault();
      closeBundle(false);
    }
  });

  /* An add to cart from inside the dialog finishes the visit: close it (the toast confirms the add). */
  document.addEventListener('packages:added', function () {
    if (mode === 'modal' && openPackageId !== null) setTimeout(function () { closeBundle(false); }, 700);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && mode === 'modal' && openPackageId !== null) closeBundle(false);
  });

  function syncWithHash() {
    var packageId = location.hash.replace('#', '');
    if (packageId && tileFor(packageId)) {
      openFromUrl(packageId);
    } else if (!packageId) {
      closeBundle(true);
    }
  }
  window.addEventListener('hashchange', syncWithHash);
  window.addEventListener('popstate', syncWithHash);

  /* packages.js runs between this file and DOMContentLoaded (both are
     deferred, in order): by now it has selected a package and written it
     to the hash. */
  document.addEventListener('DOMContentLoaded', function () {
    if (arrivalHash && tileFor(arrivalHash)) {
      openFromUrl(arrivalHash);
      /* Third-party scripts can juggle history during load (the careers
         page saw its modal knocked shut) — re-assert once. */
      setTimeout(function () {
        if (openPackageId === null && location.hash.replace('#', '') === arrivalHash) openFromUrl(arrivalHash);
      }, 1200);
    } else if (history.replaceState) {
      history.replaceState(null, '', pageUrl());
    }
  });
})();
